import { Link } from "react-router-dom";
import { ShieldOff } from "lucide-react";
import { useAuth } from "@/context/AuthContext";
import { homePath, userTitle } from "@/lib/roles";

export const AccessDenied = () => {
  const { user } = useAuth();
  return (
    <div className="min-h-[70vh] flex items-center justify-center bg-carbon px-6" data-testid="access-denied">
      <div className="border border-line bg-graphite max-w-lg w-full px-8 py-12 text-center">
        <ShieldOff size={40} className="mx-auto text-ember" />
        <h1 className="font-heading text-white uppercase tracking-tighter text-3xl mt-6">Access Denied</h1>
        <p className="text-silver text-sm mt-4 leading-relaxed">
          This dashboard is restricted. You are signed in as{" "}
          <span className="text-white font-medium">{user?.name}</span>
          <span className="text-ember font-semibold"> | {userTitle(user)}</span>{" "}
          and do not have permission to view this area.
        </p>
        <Link to={homePath(user)} data-testid="access-denied-home-btn"
          className="inline-block mt-8 bg-ember text-white text-xs uppercase tracking-widest font-bold px-8 py-3.5 hover:bg-ember/85 transition-colors">
          Go to my dashboard
        </Link>
      </div>
    </div>
  );
};
